module.exports = __webpack_public_path__ + "static/media/1987_Population_totalRate.c24a5a4b.png";